// Status do Device

export interface DeviceStatusInterface {
  idStatus: string
  descricao: string
}

export enum DeviceStatusType {
  ATIVO = 'AT',
  INATIVO = 'IN',
  PROCESSAMENTO = 'PR',
  DNS_DUPLICADO = 'DD'
}

export const DeviceStatusTypes: Array<DeviceStatusInterface> = [
  { idStatus: DeviceStatusType.ATIVO, descricao: 'Ativo' },
  { idStatus: DeviceStatusType.INATIVO, descricao: 'Inativo' },
  { idStatus: DeviceStatusType.PROCESSAMENTO, descricao: 'Em Processamento' },
  { idStatus: DeviceStatusType.DNS_DUPLICADO, descricao: 'DNS com IP duplicado' }
]

// Status de Log

export interface DeviceLogStatusInterface {
  idStatusLog: string
  descricao: string
}

export enum DeviceLogStatusType {
  ATIVADO = 'AT',
  DESATIVADO = 'DE',
  ALTERACAO_IP = 'AI',
  ALTERACAO_HOSTNAME = 'AH',
  DNS_DUPLICADO = 'DD'
}

export const DeviceLogStatusTypes: Array<DeviceLogStatusInterface> = [
  { idStatusLog: DeviceLogStatusType.ATIVADO, descricao: 'Ativado' },
  { idStatusLog: DeviceLogStatusType.DESATIVADO, descricao: 'Desativado' },
  { idStatusLog: DeviceLogStatusType.ALTERACAO_IP, descricao: 'Alteração de IP' },
  { idStatusLog: DeviceLogStatusType.ALTERACAO_HOSTNAME, descricao: 'Alteração de Hostname' },
  { idStatusLog: DeviceLogStatusType.DNS_DUPLICADO, descricao: 'DNS com IP Duplicado' }
]
